module.exports = __webpack_public_path__ + "img/W7022-full.9de46af8.jpg";